import React, { useState } from 'react'
import useGlobalSearchVerticalTabs from 'hooks/GlobalSearch/useGlobalSearchVerticalTabs'
import { SEARCH_VERTICALS } from 'constants/search'
import LayoutContainer from 'components/Common/LayoutContainer'
import GlobalSearchTabsPane from 'components/Search/GlobalSearch/GlobalSearchTabsPane'
import styled from 'styled-components'
import { rem } from 'polished'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const SearchContainer = styled(LayoutContainer)`
  position: relative;
  bottom: ${rem(56)};
  margin-bottom: -${rem(56)};
  padding-bottom: ${rem(20)};
`

interface Props {
  /**
   * Provide your own set of tabs that will appear in the search bar
   */
  tabs?: Map<SEARCH_VERTICALS, App.GlobalSearchVerticalTab>
}

function Search(props: Props) {
  const globalTabs = useGlobalSearchVerticalTabs()
  const tabs = props.tabs ?? globalTabs

  const [selectedTab, setSelectedTab] = useState<SEARCH_VERTICALS>([...tabs.keys()][0])

  return (
    <CSSBreakpoint min="desktop">
      <SearchContainer data-testid="search-container">
        <GlobalSearchTabsPane tabs={tabs} selectedTab={selectedTab} onTabSelect={setSelectedTab} />
      </SearchContainer>
    </CSSBreakpoint>
  )
}

export default React.memo(Search)
